import React from "react";

import { boxForwardRef } from "../../../helpers/common/Box/Box";
import { Text } from "../../Text";

import type { BoxComponentWithDefault } from "../../../helpers/common/Box/Box";
import type {
    TextCorePropsMultiLine,
    TextCorePropsOneLine,
} from "../../../helpers/common/TextCore/types";
import type { TextProps } from "../../Text";

type PickedTextProps = Pick<
    TextProps,
    | "children"
    | "customVarsStyles"
    | "typographyStyle"
    | "width"
    | "alignmentX"
    | "data-tsid"
>;

type LoaderLabelProps =
    | (PickedTextProps &
          Pick<TextCorePropsOneLine, "maxLines" | "truncateStyle">)
    | (PickedTextProps &
          Pick<TextCorePropsMultiLine, "maxLines" | "truncateStyle">);

const LOADER_LABEL_TEST_ID = "loader-label-test-id";

export const LoaderLabel = boxForwardRef<
    BoxComponentWithDefault<"span", LoaderLabelProps, "style" | "className">
>(({ maxLines = 1, ...props }, ref) => (
    <Text
        data-tsid={LOADER_LABEL_TEST_ID}
        {...({ ...props, maxLines } as LoaderLabelProps)}
        ref={ref}
    />
));

LoaderLabel.displayName = "Loader.Label";

export default LoaderLabel;
